import { Theme } from '@mui/material'
import { m } from 'framer-motion'
import i18n from 'i18n'
import { StylesConfig } from 'react-select'

function applyLg(size: string, styles: Record<string, any>) {
  return {
    ...(size === 'lg' && styles)
  }
}

function applyMd(size: string, styles: Record<string, any>) {
  return {
    ...(size === 'md' && styles)
  }
}

export function customStyles(
  theme: Theme,
  size: string,
  variant: string | undefined
): StylesConfig {
  return {
    control: (base) => ({
      ...base,
      width: 'fit-content',

      flexWrap: 'nowrap',
      minHeight: 32,
      direction: i18n.dir(),

      border: `1px solid ${theme.palette.input.border.primary}`,
      height: 32,
      boxShadow: '0px 1px 6px 0px #32324714 inset',
      borderRadius: 23,
      cursor: 'pointer',
      ...applyLg(size, {
        height: 52,
        minHeight: 52
      }),
      '@media (max-height: 500px)': {
        height: 38,
        minHeight: 38
      },
      ...(variant === 'no-border' && {
        border: 0,
        boxShadow: 'none',
        backgroundColor: 'inherit'
      }),
      ...(variant === 'no-border-bg' && {
        border: 0,
        boxShadow: 'none',
        borderRadius: 8,
        backgroundColor: 'transparent',
        textDecoration: 'underline',
        textUnderlineOffset: '3px',
        textDecorationColor: '#e4e4e4'
      }),
      '&:hover': {
        backgroundColor: theme.palette.background.paper,
        ...(variant === 'no-border' && {
          border: 0,

          boxShadow: '0px 1px 6px 0px #32324714 inset'
        }),
        ...(variant === 'no-border-bg' && {
          borderRadius: 8,
          background: theme.palette.background.paper
        })
      }
    }),
    valueContainer: (base) => ({
      ...base,
      display: 'flex',
      flex: 'none',
      overflow: 'none',
      height: 30
    }),
    placeholder: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      color: theme.palette.input.placeholder,
      fontSize: '0.625rem',
      fontWeight: 400,

      ...applyLg(size, {
        fontSize: '1.25rem'
      }),

      ...applyMd(size, {
        fontSize: 14
      })
    }),
    singleValue: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      display: 'flex',
      color: theme.palette.text.primary,
      fontSize: '0.75rem',
      fontWeight: 400,
      ...applyLg(size, {
        fontSize: '1.25rem'
      }),
      ...applyMd(size, {
        fontSize: 14
      })
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      color: theme.palette.text.primary,
      fontSize: '0.625rem',
      fontWeight: 400,
      ...applyLg(size, {
        fontSize: '1.25rem'
      }),
      ...applyMd(size, {
        fontSize: 14
      })
    }),
    indicatorsContainer: (base) => ({
      ...base,
      width: 'fit-content',
      height: 30,
      marginLeft: i18n.dir() === 'ltr' ? 0 : '8px',
      marginRight: i18n.dir() === 'ltr' ? '8px' : 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.text.primary,
      ...(variant === 'no-border-bg' && {
        display: 'none !important'
      }),

      '& svg': {
        width: 8
      },

      ...applyLg(size, {
        width: 'fit-content',
        height: 50,

        '& svg': {
          width: 12
        }
      }),

      '@media (max-height: 500px)': {
        height: 38,
        minHeight: 38
      }
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 23,
      border: `1px solid ${theme.palette.input.border.primary}`,
      zIndex: 99,
      width: '150px',

      transform: 'translateX(-50px)',
      boxShadow:
        '0px 1px 8px rgba(50, 50, 71, 0.08), 0px 4px 16px rgba(50, 50, 71, 0.06)'
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      width: '150px',
      minWidth: 100,
      direction: i18n.dir(),
      borderRadius: 22
    }),
    noOptionsMessage: (base) => ({
      ...base,
      fontWeight: 400,
      color: theme.palette.input.placeholder,
      fontSize: '14px'
    }),
    option: (base, props) => ({
      ...base,
      backgroundColor: 'transparent',
      color: theme.palette.text.primary,
      padding: theme.spacing(3, 4),
      fontSize: '14px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)'
      },
      ...(props.isSelected && {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        color: theme.palette.text.primary,
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.1)'
        }
      })
    })
  }
}
